import { render } from "./ActiveUsersChart.vue?vue&type=template&id=3b0c7715&ts=true"
import script from "./ActiveUsersChart.vue?vue&type=script&lang=ts"
export * from "./ActiveUsersChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__